import BackupClock from "../images/backupClock"
import Like from "../images/like"


export const useCaseIconMap = {
  BackupClock: BackupClock,
  Like: Like
}

interface Solution {
  title: string;
  description: string;
  imgEN: string
  imgTR: string
};

interface ResultPercentage {
  percent: string;
  description: string;
  icon: string;
};

interface UseCase {
  title: string;
  companyAbout: string;
  companyProblem: string;
  solution: string;
  solutions: Solution[];
  result: string;
  resultPercentages: ResultPercentage[];
  img: string;
};

export interface UseCases {
  support: UseCase;
  development: UseCase;
  processes: UseCase;
};

export const useCases: UseCases = {
  support: {
    title: "useCaseOneShortTitle",
    companyAbout: "useCaseOneAboutCompany",
    companyProblem: "useCaseOneCompanyProblem",
    solution: "useCaseOneSolution",
    solutions: [
      {
        title: "useCaseOneSolutionTitleOne",
        description: "useCaseOneSolutionDescriptionOne",
        imgEN: "9aa45aa2-6455-4812-f2a1-a32be43a6000",
        imgTR: "b0eb9b52-1778-40e6-9c18-22a7323e2800"
      },
      {
        title: "useCaseOneSolutionTitleTwo",
        description: "useCaseOneSolutionDescriptionTwo",
        imgEN: "85fa9882-db0e-4212-7f73-fc8f71ea9700",
        imgTR: "dbbb21be-20df-4d9b-8d39-c0c468c81100"
      },
      {
        title: "useCaseOneSolutionTitleThree",
        description: "useCaseOneSolutionDescriptionThree",
        imgEN: "696a5e9d-ef51-404b-98bb-7698834ef200",
        imgTR: "4990ba15-b861-402a-a6e7-7068f3c25500"
      },
    ],
    result: "useCaseOneResult",
    resultPercentages: [
      {
        percent: "%40",
        description: "useCaseOneResultPercentageOneDesc",
        icon: "BackupClock"
      },
      {
        percent: "%25",
        description: "useCaseOneResultPercentageTwoDesc",
        icon: "Like"
      },
    ],
    img: "/automation.png"
  },
  development: {
    title: "useCaseTwoShortTitle",
    companyAbout: "useCaseTwoAboutCompany",
    companyProblem: "useCaseTwoCompanyProblem",
    solution: "useCaseTwoSolution",
    solutions: [
      {
        title: "useCaseTwoSolutionTitleOne",
        description: "useCaseTwoSolutionDescriptionOne",
        imgEN: "332b9903-9e92-4be9-e407-62f99bf96f00",
        imgTR: "cb947816-b37e-450e-fb18-cf61f601e800"
      },
      {
        title: "useCaseTwoSolutionTitleTwo",
        description: "useCaseTwoSolutionDescriptionTwo",
        imgEN: "98dd5f60-593f-48ed-89fa-498aeaf78400",
        imgTR: "d4353090-1352-425c-4629-19b3af14aa00"
      },
      {
        title: "useCaseTwoSolutionTitleThree",
        description: "useCaseTwoSolutionDescriptionThree",
        imgEN: "aaa4466d-cb4a-4be6-7ee7-457a945f5200",
        imgTR: "72dfc577-fbd0-4623-a965-88d7bcef4c00"
      },
      {
        title: "useCaseTwoSolutionTitleFour",
        description: "useCaseTwoSolutionDescriptionFour",
        imgEN: "42611cac-e4b4-4f4a-5010-c83e930a9500",
        imgTR: "15d0983f-ee59-4e24-84f4-ebff1f011a00"
      },
    ],
    result: "useCaseTwoResult",
    resultPercentages: [
      {
        percent: "%60",
        description: "useCaseTwoResultPercentageOneDesc",
        icon: "BackupClock"
      },
      {
        percent: "%70",
        description: "useCaseTwoResultPercentageTwoDesc",
        icon: "Like"
      },
    ],
    img: "/automation.png"
  },
  processes: {
    title: "useCaseThreeShortTitle",
    companyAbout: "useCaseThreeAboutCompany",
    companyProblem: "useCaseThreeCompanyProblem",
    solution: "useCaseThreeSolution",
    solutions: [
      {
        title: "useCaseThreeSolutionTitleOne",
        description: "useCaseThreeSolutionDescriptionOne",
        imgEN: "ee1acc02-b88f-48c4-f4fa-d29e13eaca00",
        imgTR: "0d5a89bf-ea96-4605-8e9f-14eb17e72000"
      },
      {
        title: "useCaseThreeSolutionTitleTwo",
        description: "useCaseThreeSolutionDescriptionTwo",
        imgEN: "a0e4f575-fc39-4f98-1af2-c2da1b6df700",
        imgTR: "59fd5244-808b-448c-d214-e88c509e4700"
      },
      {
        title: "useCaseThreeSolutionTitleThree",
        description: "useCaseThreeSolutionDescriptionThree",
        imgEN: "0050bbd7-b6a8-4c94-5d92-23c0b5b69200",
        imgTR: "c8aeefdd-2788-4f42-fd1b-531063ba5700"
      },
      {
        title: "useCaseThreeSolutionTitleFour",
        description: "useCaseThreeSolutionDescriptionFour",
        imgEN: "1f9be178-8bb2-4c10-4829-5ddcde5c5d00",
        imgTR: "a7ef6843-9ff5-4c19-6f96-a5e770581e00"
      },
    ],
    result: "useCaseThreeResult",
    resultPercentages: [
      {
        percent: "%50",
        description: "useCaseThreeResultPercentageOneDesc",
        icon: "BackupClock"
      },
    ],
    img: "/automation.png"
  },
}